<script setup lang="ts">
    import EchoButton from '../EchoButton.vue';
    import IconButton from '../IconButton.vue';
    import { __ } from '@/js/stores/expressions';
    import EchoPopover from '../EchoPopover.vue';
    import { CopyIcon, SettingsIcon, TrashIcon } from '@lucide/vue';

    defineProps<{
        showDelete?: boolean;
    }>();

    const emit = defineEmits<{
        (e: 'copyDashboard'): void;
        (e: 'deleteDashboard'): void;
        (e: 'addWidget'): void;
    }>();
</script>
<template>
    <div class="h-full relative">
        <IconButton
            v-if="!showDelete"
            :tooltip="__('dashboard-copy-description')"
            area-size="size-8"
            @click="emit('copyDashboard')"
        >
            <CopyIcon class="size-full" />
        </IconButton>
        <EchoPopover v-else type="menu" position="bottom-end">
            <template #button="{ anchor, togglePopover, buttonAttrs }">
                <IconButton
                    :ref="anchor"
                    :tooltip="__('settings')"
                    area-size="size-8"
                    v-bind="buttonAttrs"
                    @click="togglePopover"
                >
                    <SettingsIcon class="size-full" />
                </IconButton>
            </template>

            <template #popover>
                <EchoButton variant="block" @click="emit('copyDashboard')">
                    <template #icon-left><CopyIcon /></template>
                    {{ __('dashboard-copy-description') }}
                </EchoButton>
                <EchoButton variant="block" @click="emit('deleteDashboard')">
                    <template #icon-left><TrashIcon /></template>
                    {{ __('dashboard-delete-dashboard') }}
                </EchoButton>
            </template>
        </EchoPopover>
    </div>
</template>
